export const environment = {
    production: false,
    envName: "Development",
    appVersion: "2.0.0",
    logo: "assets/image/grupo-centurion-logo.jpg",
    //urlApiGrupoCenturion: "https://localhost:7137/api/",
    urlApiGrupoCenturion: "https://inventario.movicent.api.dev.thsmweb.com.mx/api/"
};